/**
 * One-time axios bootstrap — runs on import. Ensures every API call sends
 * the auth cookie (httpOnly access_token) and auto-redirects to /login on
 * 401 (except the auth endpoints themselves, which surface their own errors).
 */
import axios from "axios";

axios.defaults.withCredentials = true;

let onUnauthorized = null;
export function setUnauthorizedHandler(fn) {
  onUnauthorized = fn;
}

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    if (status === 401 && !url.includes("/api/auth/")) {
      if (onUnauthorized) onUnauthorized();
    }
    return Promise.reject(error);
  },
);

export default axios;
